import React, {Component} from 'react'
import {connect} from 'react-redux'
import WithAjax from '../common/helpers/WithAjax'
import {fetchSkillVendorDevicesSuccess} from '../../actions/pages/skillvendor-page'
import Table from '../../tables/reactable/DefaultTable'

class DevicesGrid extends Component {
  constructor() {
    super()
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.onFilter = this.onFilter.bind(this)
    this.state = {
      itemsPerPage: 10,
      search: '',
      filter: {
        MobilePlatformType: ''
      }
    }
    this.columns = [
      'PlatformIcon',
      'MobilePlatformType',
      'AppVersion',
      'AppLanguage',
      'FirstCheckIn',
      'LastCheckIn',
      'ApplicationInstanceId'
    ]
    this.columnNames = [
      '',
      'Platform',
      'Version',
      'Language',
      'First Check-In',
      'Last Check-In',
      'Application Instance ID'
    ]
  }

  componentDidMount() {
    if (this.props.devices === null){
      this.fetchDevices();
    }
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  fetchDevices() {
    let url = 'skillVendors/' + this.props.skillVendorId + '/devices'

    this.props.ajax.get(url, true, (data) => {
      this.props.fetchSkillVendorDevicesSuccess(data);
    });
  }

  onSearch(e) {
    e.preventDefault()
    this.setState({
      search: e.target.value
    })
    return false
  }

  onFilter(filter){
    this.setState({
      filter: filter
    })
  }

  render() {
    if (this.props.devices === null) {
      return (<div />)
    }

    let items = this.props.devices.map(item => {
      return Object.assign({}, item, {
        PlatformIcon: (<img src={'/assets/icons/' + item.MobilePlatformType.toLowerCase() + '.png'} alt="" />)
      })
    });

    return (
      <div>
        <Table
          items={items}
          columns={this.columns}
          columnNames={this.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          searchable={[
            'AppVersion',
            'ApplicationInstanceId'
          ]}
          search={this.state.search}
          onSearch={this.onSearch}
          filterable={[{
            column: 'MobilePlatformType',
            filters: [
              {
                value: 'android',
                label: 'Android'
              },
              {
                value: 'ios',
                label: 'iOS'
              }
            ]
          }]}
          filter={this.state.filter}
          onFilter={this.onFilter}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={false}
          sortable={[
            'MobilePlatformType',
            'AppVersion',
            'AppLanguage',
            'FirstCheckIn',
            'LastCheckIn'
          ]}
          defaultSort={{ column: 'LastCheckIn', direction: 'desc' }}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  skillVendorId: state.skillVendorPage.overview.Id,
  devices: state.skillVendorPage.devices
})
const mapDispatchToProps = dispatch => ({
  fetchSkillVendorDevicesSuccess(devices) { dispatch(fetchSkillVendorDevicesSuccess(devices)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(DevicesGrid))
